(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["creastix-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.CreastixOffer) return;

    const STORAGE_KEY = 'trulife_offer_v1';
    const configElement = document.querySelector('[data-creastix-offer-config]');
    let config = { minutes: 10, code: 'STIX10', repeatDays: 0 };
    try {
      if (configElement) config = { ...config, ...JSON.parse(configElement.textContent) };
    } catch (error) {}

    // Only a page with the booted banner may start a timer. Anywhere else (e.g. rendered from the layout)
    // the script just enforces an existing one, so an expired code can't ride along to checkout.
    const canStart = Boolean(configElement);
    const durationMs = Math.max(1, Number(config.minutes) || 10) * 60 * 1000;
    const params = new URLSearchParams(window.location.search);

    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      } catch (error) {
        return null;
      }
    };
    const write = (value) => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      } catch (error) {}
    };

    // Work out this browser's offer: start one on the first visit, never restart it on its own.
    let saved = read();
    if (params.has('offer-reset')) saved = null;
    if (params.has('offer-expire')) saved = { deadline: Date.now(), expired: true };
    if (saved && saved.expired && Number(config.repeatDays) > 0) {
      const repeatMs = Number(config.repeatDays) * 24 * 60 * 60 * 1000;
      if (Date.now() - saved.deadline > repeatMs) saved = null;
    }
    if (!saved && !canStart) return;
    if (!saved) saved = { deadline: Date.now() + durationMs, expired: false, code: String(config.code || '').trim() };
    if (saved.deadline <= Date.now()) saved.expired = true;
    write(saved);
    const code = String(saved.code || config.code || '').trim();

    // Keep our code on the cart only while the offer runs and no other code is there. Other codes
    // are never touched. Resolves true when the cart holds someone else's code.
    const isOurs = (entry) => entry.toLowerCase() === code.toLowerCase();
    const syncCartCode = async (wanted) => {
      if (!code) return false;
      try {
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        const codes = (cart.discount_codes || []).map((entry) => entry.code);
        const others = params.has('offer-reset') ? [] : codes.filter((entry) => !isOurs(entry));
        const keep = wanted && others.length === 0;
        if (keep !== codes.some(isOurs)) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: (keep ? [...others, code] : others).join(',') }),
          });
        }
        // Once an expired code is off the cart, later page views can skip the cart request.
        if (!wanted && saved.expired && !saved.cleaned) {
          saved.cleaned = true;
          write(saved);
        }
        return others.length > 0;
      } catch (error) {
        return false;
      }
    };

    const pad = (value) => String(value).padStart(2, '0');
    const linkCode = decodeURIComponent((document.cookie.match(/(?:^|; )discount_code=([^;]*)/) || [])[1] || '');
    let state = saved.expired ? 'expired' : 'active';
    if (state === 'active' && linkCode && !isOurs(linkCode)) state = 'other';
    let timer;

    const render = () => {
      const remaining = Math.max(0, saved.deadline - Date.now());

      if (state === 'active' && remaining === 0) {
        state = 'ended';
        saved.expired = true;
        write(saved);
        syncCartCode(false);
        window.clearInterval(timer);
      }

      document.documentElement.dataset.offer = state;
      const totalSeconds = Math.ceil(remaining / 1000);
      const minutes = pad(Math.floor(totalSeconds / 60));
      const seconds = pad(totalSeconds % 60);
      document.querySelectorAll('[data-offer-clock]').forEach((element) => {
        element.textContent = `${minutes}:${seconds}`;
      });
      document.querySelectorAll('[data-offer-minutes]').forEach((element) => {
        element.textContent = minutes;
      });
      document.querySelectorAll('[data-offer-seconds]').forEach((element) => {
        element.textContent = seconds;
      });
      document.querySelectorAll('[data-offer-progress]').forEach((element) => {
        element.style.setProperty('--offer-progress', (remaining / durationMs).toFixed(4));
      });
      document.dispatchEvent(new CustomEvent('creastix:offer', { detail: { state, remaining } }));
    };

    window.CreastixOffer = {
      get state() {
        return state;
      },
      get remaining() {
        return Math.max(0, saved.deadline - Date.now());
      },
      code,
    };

    render();
    if (state === 'active') timer = window.setInterval(render, 1000);
    if (state === 'expired' && saved.cleaned) return;
    syncCartCode(state === 'active').then((hasOtherCode) => {
      if (!hasOtherCode || state !== 'active') return;
      state = 'other';
      window.clearInterval(timer);
      render();
    });

    // Sections re-rendered in the theme editor need their clocks filled in again.
    document.addEventListener('shopify:section:load', render);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-image-preview"] && !Shopify.designMode) return;
  try {
    window.showSocialImage = function showSocialImage() {
    const existingPreview = document.getElementById('SocialImagePreview');
    if (existingPreview) existingPreview.remove();

    const imageMeta = document.querySelector('meta[property="og:image"]');
    const imageUrl = imageMeta?.content;

    if (!imageUrl) {
      window.alert('No og:image metadata was found on this page.');
      return;
    }

    const overlay = document.createElement('div');
    const panel = document.createElement('div');
    const title = document.createElement('h2');
    const image = document.createElement('img');
    const url = document.createElement('p');
    const closeButton = document.createElement('button');

    overlay.id = 'SocialImagePreview';
    overlay.className = 'social-image-preview';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'SocialImagePreviewTitle');

    panel.className = 'social-image-preview__panel';
    title.id = 'SocialImagePreviewTitle';
    title.className = 'social-image-preview__title';
    title.textContent = 'Social sharing image';
    image.className = 'social-image-preview__image';
    image.src = imageUrl;
    image.alt = '';
    url.className = 'social-image-preview__url';
    url.textContent = imageUrl;
    closeButton.className = 'social-image-preview__close';
    closeButton.type = 'button';
    closeButton.textContent = 'Close';

    const closePreview = () => {
      overlay.remove();
      document.removeEventListener('keydown', handleKeydown);
    };
    const handleKeydown = (event) => {
      if (event.key === 'Escape') closePreview();
    };

    closeButton.addEventListener('click', closePreview);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closePreview();
    });
    document.addEventListener('keydown', handleKeydown);

    panel.append(title, image, url, closeButton);
    overlay.append(panel);
    document.body.append(overlay);
    closeButton.focus();
  };
  } catch(e) { console.error(e); }
})();

})();
